/*
 * @Description: '首页'所有的路由
 * @Author: mike ma *
 * @Date: 2021-02-24 16:50:00
 * @LastEditTime: 2021-03-03 20:12:42
*/

export default [
    {
        path: '',
        component: resolve => require(['@/views/hi'], resolve),
        name: 'Hi',
        meta: {
            nav: '平台跳转页'
        }
    },
    

]



// WEBPACK FOOTER //
// ./src/router/hi.js